export const estilo = {
  corDaFonte: '#E66767',
  corDaFonte2: '#FFEBD9',
  corDoFundo: '#FFFFFF',
  corDaEstrela: '#FFB930'
}

export const Breakpoints = {
  tablet: '768px',
  desktop: '1024px'
}

/*
    @media (max-width: ${Breakpoints.desktop}) {
      background-color: green;
    }

    @media (max-width: ${Breakpoints.tablet}) {
      background-color: red;
    }

*/
